import commCdDescTable from './commCdDescTable';

export default {
	commCdDescTable
};

export { commCdDescTable };
